import { render, staticRenderFns } from "./HuiDan.vue?vue&type=template&id=433aacb0&scoped=true&"
import script from "./HuiDan.vue?vue&type=script&lang=js&"
export * from "./HuiDan.vue?vue&type=script&lang=js&"
import style0 from "./HuiDan.vue?vue&type=style&index=0&id=433aacb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433aacb0",
  null
  
)

export default component.exports